import React, { useState } from 'react'
import Loader from '../Loader/Loader'
import { message, Button } from 'antd'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { createSubscription } from '../../Web Apis/Apis';
import { useRef } from "react";

function CreateBilling({ showCreateModal, setShowCreateModal, action, setAction }) {
    const [open, setOpen] = useState(showCreateModal)
    const [loading, setLoading] = useState(false)
    const [image, setImage] = useState(null)

    const fileInputRef = useRef(null);  // Create a reference for file input

    const closeModal = () => {
        setOpen(false)
        setShowCreateModal(false)
    }

    const formik = useFormik({
        initialValues: {
            price: "",
            credit: "",
            subscriptionImage: null
        },
        validationSchema: Yup.object({
            price: Yup.string()
                .matches(/^[0-9]+$/, "Only numbers are allowed")
                .required("Price is required"),

            credit: Yup.string()
                .matches(/^[0-9]+$/, "Only numbers are allowed")
                .required("Credit is required"),

            subscriptionImage: Yup.string().required("Image is required")
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)
                const data = new FormData()
                if (values.price) data.append("price", values.price)
                if (values.credit) data.append("credit", values.credit)
                if (values.subscriptionImage) data.append("image", values.subscriptionImage)

                const response = await createSubscription(data)
                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    resetForm()
                    setOpen(false)
                    setShowCreateModal(false)
                    setAction(!action)
                }

            } catch (error) {
                console.log("Error while creating admin", error.message)
                message.error(error?.response?.data?.message || "Error while creating admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            formik.setFieldValue("subscriptionImage", file);
        }
    };

    const handleRemoveImage = () => {
        setImage(null);
        formik.setFieldValue("subscriptionImage", null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";  // Reset the file input field
        }
    };


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[800px] h-[550px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Create Credits
                </h3>
                <form onSubmit={formik.handleSubmit} className="p-8">
                    <div className="w-full">
                        <label className="block mb-1 mt-2 text-xl font-bold">Price</label>
                        <input
                            type="text"
                            name="price"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.price}
                            placeholder='Enter price of subscription'
                        />
                        {formik.errors.price && (
                            <p className="text-red-600 ml-2">{formik.errors.price}</p>
                        )}
                    </div>

                    <div className="w-full">
                        <label className="block mb-1 mt-4 text-xl font-bold">Credits</label>
                        <input
                            type="text"
                            name="credit"
                            className="border border-gray-800 p-2 w-full "
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.credit}
                            placeholder='Enter number of credits'
                            
                        />
                        {formik.errors.credit && (
                            <p className="text-red-600 ml-2">{formik.errors.credit}</p>
                        )}
                    </div>

                    <div className="w-full">
                        <label className="block mb-4 mt-4 text-xl font-bold">Image:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="cursor-pointer text-2xl"
                            ref={fileInputRef}
                        />

                        {formik.errors.subscriptionImage && (
                            <p className="text-red-600">{formik.errors.subscriptionImage}</p>
                        )}

                        {image && (
                            <div className="mt-2 flex items-center border border-gray-800">
                                <img
                                    src={image}
                                    alt="Profile Preview"
                                    className="border border-gray-800 w-16 h-16 object-cover rounded-full mr-2"
                                />
                                <Button
                                    type="button"
                                    className="bg-red-600 text-white cursor-pointer"
                                    onClick={handleRemoveImage}
                                >
                                    Remove Image
                                </Button>
                            </div>
                        )}
                    </div>

                    <div className="flex justify-center gap-6 mt-6">
                        <button
                            onClick={closeModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            {formik.isSubmitting ? 'Creating...' : 'Create'}
                        </button>
                    </div>
                    {loading && <Loader />}
                </form>
            </div>
        </div>
    )
}

export default CreateBilling